import React from 'react';
import { IUICfgUIHtmlBlockUIElement } from '@canvas-logic/clp-api-types';
import { CfgUIElementState } from './CfgUIElementState';
import { ReactNode } from 'react';
import ThemeDefinition from '@/ui-kit/domain/ThemeDefinition';
import DOMPurify from 'dompurify';

export class HtmlBlockUIElementState extends CfgUIElementState {
  render(): ReactNode {
    return (
      <div
        key={this.element.id}
        className={ThemeDefinition.htmlBlock.root}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.html) }}
      />
    );
  }

  get html() {
    return this.element.html;
  }

  constructor(private readonly element: IUICfgUIHtmlBlockUIElement) {
    super();
  }
}
